import { useCountryHook } from "@/features/case/use-country";
import { usePermission } from "@/features/case/use-permission";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setRetainCaseId } from "@/features/retain_state/retainStateSlice";

const GlobalCachedComponent = () => {
    const location = useLocation();
    const [caseId, setCaseId] = useState<string | null>(null);
    const [shouldFetch, setShouldFetch] = useState(false);
    const dispatch=useDispatch()
     useCountryHook();
     useEffect(() => {
        const pathSegments = location.pathname.split('/');
        const caseIdIndex = pathSegments.indexOf('case') + 1;
        const extractedCaseId = pathSegments[caseIdIndex] || null;
        setCaseId(extractedCaseId);
      }, [location]);
	useEffect(() => {
		if (caseId) {
            dispatch(setRetainCaseId({caseId:caseId}))
			setShouldFetch(true);
		}
	}, [caseId,dispatch]);

    usePermission(caseId,shouldFetch);
    return null;

};
export default GlobalCachedComponent;